import * as React from 'react';

import {
    Description,
    Dialog,
    DialogBody,
    DialogHeader,
    Heading,
    ListSkeleton,
} from '@gitbook/spine-react';

import { UpgradeDialogProvider } from '../../../../Components';
import { useCurrentOrganization, useSiteContext } from '../../../../state';
import { SitePermissionsList } from './SitePermissionsList';

/**
 * Dialog to invite members to a site. Accessible via /o/{org}/sites/{site}/members/invite.
 */
export function SiteMembersAccessDialog() {
    const { site } = useSiteContext();
    const organization = useCurrentOrganization();

    return (
        <Dialog>
            <DialogHeader>
                <Heading>Invite to {site.title}</Heading>
                <Description>
                    {organization.sso
                        ? 'Invite existing members and teams.'
                        : 'Invite existing members and teams, or add new people by email.'}
                </Description>
            </DialogHeader>
            <UpgradeDialogProvider>
                <React.Suspense
                    fallback={
                        <DialogBody>
                            <ListSkeleton items={3} />
                        </DialogBody>
                    }
                >
                    <SitePermissionsList />
                </React.Suspense>
            </UpgradeDialogProvider>
        </Dialog>
    );
}
